import Loader from './Loader'

export interface CardProps {
  className?: string
  title?: string
  children: React.ReactNode
  visible?: boolean
}

function Card({ className, title, children, visible = false }: CardProps) {
  return (
    <div className={`${className} bg-white p-4`}>
      {title !== '' && <div className='text-base text-[#001E61] font-semibold mb-4'>{title}</div>}
      <Loader visible={visible} />
      {visible ? <div className='w-full min-h-[33vh]' /> : children}
    </div>
  )
}

Card.defaultProps = {
  className: '',
  title: '',
  visible: false,
}

export default Card
